<template lang="pug">
#view-container
  app-header
  .content-container
    //- .progress-bar
    transition(name="swipe" mode="out-in")
      .question(:key='"q" + index') {{question[0]}}
    transition(name="swipe" mode="out-in")
      .options(:key='"o" + index')
        .option(
          v-for='([text, option], index) in Object.entries(question[1])'
          :style="{'background-image': 'url(/_/lv-quiz/img/backgrounds/'+option.background+')'}"
          @click='selectOption(index)'
          :class='{["option-" + index]: true}')
          .overlay
          .text(v-html='text.replace(/\\n/gmi, "<br>")')
    .button-container
      router-link.button(to='/') Take the Quiz Again

</template>

<script>
export default {
  data(){
    return {
      index: 0,
    }
  },
  async mounted(){
    await this.$store.commit('resetQuiz')
    Array.from(document.querySelectorAll("*")).forEach(el => el.scrollTo(0, 0))
  },
  computed: {
    questions(){
      return this.$store.state.quiz.questions
    },
    question(){
      return Object.entries(this.questions)[this.index]
    },
  },
  methods: {
    selectOption(index){
      const option = Object.values(Object.values(this.questions)[this.index])[index]
      this.$store.commit('tally', option.products)
      
      if(this.index + 1 == Object.keys(this.questions).length){
        // Keep going
        this.$router.push({name:"Bag"})
        return 
      }

      this.index++

      console.log(this.$store.state.quiz.tally)
      console.log(this.$store.getters.topProducts)

      Array.from(document.querySelectorAll("*")).forEach(el => el.scrollTo(0, 0))
    },
  },
}
</script>

<style lang="sass" scoped>
@import @/sass/_all.sass
#view-container
  overflow-x: hidden
  width: 100%
  height: 100%
  display: grid
  grid-template-columns: 1fr
  grid-template-rows: auto 1fr
  padding-bottom: 64px
  .content-container
    width: 100%
    height: 100%
    display: grid
    grid-template-columns: 1fr
    grid-template-rows: auto 1fr auto
    transition: all $transition-fast
    padding: 0 10%
    +range($break-mobile + 1, $break-tablet)
      padding: 0 30px
    +range(0, $break-mobile)
      padding: 0 26px
    .progress-bar
      position: absolute

    .question
      font-size: 32px
      line-height: 40px
      font-weight: 700
      margin-top: 56px
      margin-bottom: 40px
      text-align: center
      padding: 0 24px
      flex-grow: 0
      flex-shrink: 0
      +range(0, $break-mobile)
        font-size: 28px
        line-height: 40px
        font-weight: 600
        margin-top: 24px
        margin-bottom: 20px

    .options
      width: 98%
      flex-grow: 1
      flex-shrink: 1
      $gap: 16px
      // I went back to grids
      display: grid
      grid-template-columns: 1fr 1fr
      grid-template-rows: 1fr 1fr
      grid-gap: 16px
      +range(0, $break-mobile)
        grid-template-columns: 1fr

      // FLEX DOES NOT WORK
      // display: flex
      // flex-wrap: wrap
      // flex-direction: row
      // justify-content: space-between
      // align-content: space-between
      // .option
      //   flex-grow: 1
      //   flex-shrink: 1
      //   width: calc(50% - #{$gap / 2})
      //   max-width: calc(50% - #{$gap / 2})
      //   flex-basis: calc(50% - #{$gap / 2})
      //   height: calc(50% - #{$gap / 2})
      // +range(0, $break-mobile)
      //   flex-wrap: nowrap
      //   flex-direction: column
      //   .option
      //     width: 100%
      //     flex-basis: 100%
      //     max-width: 100%
      //     margin-bottom: $gap

      // Trying out absolute now
      // .option
      //   +range(0, $break-mobile - 1px)
      //     width: 100%
      //     margin-bottom: $gap
      //   +range($break-mobile)
      //     position: absolute
      //     width: calc(50% - #{$gap / 2})
      //     height: calc(50% - #{$gap / 2})
      //     &.option-0
      //       top: 0
      //       left: 0
      //     &.option-1
      //       top: 0
      //       right: 0
      //     &.option-2
      //       bottom: 0
      //       left: 0
      //     &.option-3
      //       bottom: 0
      //       right: 0
            

      .option
        cursor: pointer
        background-position: top center
        background-repeat: no-repeat
        background-size: cover
        min-height: 150px
        +range(0, $break-mobile)
          min-height: 200px
        $border: 6px
        .overlay
          position: absolute
          top: 0
          bottom: 0
          right: 0
          left: 0
          background: linear-gradient(180deg, rgba(25, 17, 11, 0) 0%, #19110B 100%)
          border: 0px solid $color-gray
          transition: all $transition-fast
        +range($break-mobile + 1)
          &:hover .overlay
            border: $border solid $color-gray
        .text
          color: white
          font-weight: 500
          font-size: 20px
          line-height: 28px
          text-align: center
          position: absolute
          bottom: 0
          left: 0
          right: 0
          padding: 24px 24px

    .button-container
      margin-top: 40px
      text-align: center
      .button
        width: auto
</style>